(function() {
  'use strict';

  function initDoubleSidedProduct() {
    // 1. Thumbnail switching
    const thumbButtons = document.querySelectorAll('.ds-thumbs-row .ds-thumb');
    const mainImg = document.querySelector('.ds-stage-img');

    if (thumbButtons.length > 0 && mainImg) {
      thumbButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          thumbButtons.forEach(btn => btn.classList.remove('ds-thumb-active'));
          this.classList.add('ds-thumb-active');
          const newUrl = this.getAttribute('data-img-url');
          if (newUrl) {
            // srcset overrides src: must be updated (or removed) or the visible image never changes
            const responsive = newUrl.replace(/([?&])width=\d+/, '$1width=');
            if (responsive !== newUrl) {
              mainImg.srcset = [352, 832, 1000].map(w => responsive + w + ' ' + w + 'w').join(', ');
            } else {
              mainImg.removeAttribute('srcset');
            }
            mainImg.src = newUrl;
          }
        });
      });
    }

    // 2. Variant selector sync
    const variantSelects = document.querySelectorAll('.ds-variant-select');
    const stickyVariantTitle = document.querySelector('.ds-sticky-variant-title');
    const stickyPrice = document.querySelector('.ds-sticky-price');

    function syncVariant(selectedOption, sourceSelect) {
      if (!selectedOption) return;
      const variantId = selectedOption.value;
      const optionText = selectedOption.textContent.trim();
      const cleanText = optionText.split(' - ')[0].trim();
      const priceText = optionText.textContent ? '' : '';
      
      const priceMatch = optionText.match(/\$[\d.]+/);
      const priceStr = priceMatch ? priceMatch[0] : '';

      if (stickyVariantTitle) {
        stickyVariantTitle.textContent = cleanText;
      }
      if (stickyPrice && priceStr) {
        stickyPrice.textContent = priceStr;
      }

      if (variantId) {
        document.querySelectorAll('input[name="id"], .ds-variant-id, .ds-sticky-variant-id').forEach(input => {
          input.value = variantId;
        });
      }

      variantSelects.forEach(select => {
        if (select !== sourceSelect && select.value !== variantId) {
          select.value = variantId;
        }
      });
    }

    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        syncVariant(this.options[this.selectedIndex], this);
      });
      if (select.options.length > 0) {
        syncVariant(select.options[select.selectedIndex], select);
      }
    });

    // 3. Sticky bar show/hide
    const stickyBar = document.getElementById('ds-sticky-bar') || document.querySelector('.ds-sticky-bar');
    if (stickyBar) {
      const thresholdAttr = stickyBar.getAttribute('data-threshold');
      const threshold = thresholdAttr ? parseInt(thresholdAttr, 10) : 700;

      let ticking = false;
      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            if (window.scrollY > threshold) {
              stickyBar.classList.add('ds-sticky-visible');
            } else {
              stickyBar.classList.remove('ds-sticky-visible');
            }
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    }

    // 4. Flip animation
    const flipBtn = document.getElementById('ds-flip-trigger') || document.querySelector('.ds-flip-btn');
    if (flipBtn) {
      flipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const stage = this.closest('.ds-stage');
        if (stage) {
          const imgs = stage.querySelectorAll('.ds-stage-img');
          if (imgs.length > 1) {
            imgs.forEach(img => img.classList.toggle('ds-face-hidden'));
          }
        }
      });
    }

    // 5. Add to cart via AJAX — includes line item properties + syncs cart attributes
    const cartForms = document.querySelectorAll('.ds-buy-form, .ds-sticky-form, .ds-final-cta-form');

    cartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn ? submitBtn.innerHTML : 'Add to Cart';

        let variantIdInput = form.querySelector('input[name="id"]');
        let variantId = variantIdInput ? variantIdInput.value : null;

        if (!variantId) {
          const select = document.querySelector('.ds-variant-select');
          if (select) variantId = select.value;
        }

        if (!variantId) return;

        // Read line item properties from hidden inputs
        const backdropSelection = form.querySelector('input[name="properties[Backdrop Selection]"]');
        const backdropIds = form.querySelector('input[name="properties[_backdrop_ids]"]');
        const backdropImages = form.querySelector('input[name="properties[Backdrop Image URLs]"]');

        // Build properties object — only include non-empty values
        const properties = {};
        if (backdropSelection && backdropSelection.value) {
          properties['Backdrop Selection'] = backdropSelection.value;
        }
        if (backdropIds && backdropIds.value) {
          properties['_backdrop_ids'] = backdropIds.value;
        }
        if (backdropImages && backdropImages.value) {
          properties['Backdrop Image URLs'] = backdropImages.value;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = '<span>Adding...</span>';
        }

        const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
        const cartUpdateUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => {
              throw new Error(data.description || data.message || 'Could not add product to cart');
            });
          }
          return response.json();
        })
        .then(data => {
          // --- SYNC: Also set cart attributes so the cart page "already selected" note shows ---
          if (properties['Backdrop Selection']) {
            return fetch(cartUpdateUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                attributes: {
                  'Backdrop Selection': properties['Backdrop Selection'],
                  'Backdrop Image URLs': properties['Backdrop Image URLs'] || '',
                  'Backdrop Count': properties['_backdrop_ids'] ? properties['_backdrop_ids'].split(',').length : 0,
                  '_backdrop_ids': properties['_backdrop_ids'] || ''
                }
              })
            });
          }
          return Promise.resolve();
        })
        .then(() => {
          if (submitBtn) {
            submitBtn.innerHTML = '<span>Added! Redirecting...</span>';
          }
          setTimeout(() => {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
          }, 400);
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
          alert(error.message || 'There was an error adding this item to your cart.');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDoubleSidedProduct);
  } else {
    initDoubleSidedProduct();
  }
})();
